import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavClick = (e, path) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    navigate(path);
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">Move n Muse</div>
          <div className="footer-links">
            <Link to="/" onClick={(e) => handleNavClick(e, "/")}>Home</Link>
            <Link to="/events" onClick={(e) => handleNavClick(e, "/events")}>Events</Link>
            <Link to="/reviews" onClick={(e) => handleNavClick(e, "/reviews")}>Reviews</Link>
            <Link to="/about" onClick={(e) => handleNavClick(e, "/about")}>About</Link>
            <Link to="/blog" onClick={(e) => handleNavClick(e, "/blog")}>Blog</Link>
            <Link to="/goods" onClick={(e) => handleNavClick(e, "/goods")}>Goods</Link>
          </div>
          <div className="footer-links footer-links-legal">
            <Link to="/terms-of-service" onClick={(e) => handleNavClick(e, "/terms-of-service")}>Terms of Service</Link>
            <Link to="/privacy-policy" onClick={(e) => handleNavClick(e, "/privacy-policy")}>Privacy Policy</Link>
          </div>
          <div className="footer-contact">
            <a href="mailto:admin@movenmuse.com">
              <i className="bi bi-envelope"></i> admin@movenmuse.com
            </a>
            <a href="https://instagram.com/move_n_muse" target="_blank" rel="noopener noreferrer">
              <i className="bi bi-instagram"></i> @move_n_muse
            </a>
          </div>
          <p className="footer-copyright">&copy; 2026 Move n Muse. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
